import React from 'react'
import Header from '../Components/Header';
import About from '../Components/About';
import Footer from '../Components/Footer';
import Showact from '../Components/Showact';
import Latestproduct from '../Components/Latestproduct';
import slide01 from '../assests/img/hero-banner-01.jpg';
import slide02 from '../assests/img/hero-banner-02.jpg';
import slide03 from '../assests/img/hero-banner-03.jpg';
import slide04 from '../assests/img/hero-banner-04.jpg';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet-async";


import Slider from "react-slick";
import Bestsellerproduct from '../Components/Bestsellerproduct';

function App() {
   
  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

return (
    <div >
     <Helmet>
        <title>Mobile Acc | Complete Range of Mobile Accessories</title>
        <meta
          name="description"
          content="Mobile Acc | Complete Range of Mobile Accessories"
        />
        <meta
          name="keywords"
          content="mobile accessories, smartphone cases, mobile phone covers, mobile accessories India, mobile phone accessories"
        />
      </Helmet>

      <Header />
      {/* <Showlist/> */}

      <div className='container main-slider-container'>

      

<div className='main-slider'>
      <Slider {...settings}>
      <div>
        <Link to="/category/58">
       <img src={slide01}/>
       </Link>
      </div>
      <div>
        <Link to="/category/42">
       <img src={slide02}/>
       </Link>
      </div>
       <div>
       <Link to="/category/40">
       <img src={slide03}/>
       </Link>
      </div>
      <div>
       <Link to="/category/26">
       <img src={slide04}/>
       </Link>
      </div>
    </Slider>

</div>

      </div>
<About/>
<Bestsellerproduct/>
<Showact/>
<Latestproduct/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<Footer/>
 </div>
)

}

export default App;
